<div class="bg-white/40 dark:bg-dark/10 rounded-3xl">
  <div class="flex flex-col gap-2 p-4 sm:flex-row sm:items-center sm:justify-between">
    <div>
      <h1 class="text-base font-semibold text-black dark:text-white">Email Template</h1>
      <p class="text-sm text-gray-500 dark:text-white-dark">
        Manage email templates used for client outbound notifications.
      </p>
    </div>
  </div>

  @if (P.EMAIL_TEMPLATE_LIST | hasPermission) {
  <div
    class="rounded-3xl border border-white-light/80 bg-white p-4 shadow-sm dark:border-[#191e3a] dark:bg-[#0e1726]"
  >
    <app-list-module-surface
      [config]="listSurfaceConfig"
      [filters]="listFilters"
      [errorMessage]="errorMessage"
      [loading]="loading"
      [meta]="meta"
      [rowCount]="rows.length"
      (filtersChange)="onListFiltersChange($event)"
      (pageChange)="onListPageChange($event)"
    >
      <app-email-configuration-table
        listTable
        [rows]="rows"
        [loading]="loading"
        (toggleStatus)="onToggleStatus($event)"
        (preview)="openPreview($event)"
      />
    </app-list-module-surface>
  </div>
  } @else {
  <div
    class="rounded-3xl border border-white-light/80 bg-white p-8 text-center shadow-sm dark:border-[#191e3a] dark:bg-[#0e1726]"
  >
    <p class="text-sm text-gray-500 dark:text-white-dark">
      You do not have permission to view email templates.
    </p>
  </div>
  }
</div>

@if (previewOpen && (P.EMAIL_TEMPLATE_LIST | hasPermission)) {
  <dialog
    open
    class="fixed inset-0 z-[999] m-0 flex h-full max-h-none w-full max-w-none items-center justify-center border-0 bg-black/50 p-4"
    aria-labelledby="email-preview-title"
    (click)="closePreview()"
    (keydown.escape)="closePreview()"
  >
    <div
      class="max-h-[90vh] w-full max-w-3xl overflow-hidden rounded-2xl bg-white shadow-xl dark:bg-[#0e1726]"
      (click)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()"
    >
      <div class="flex items-center justify-between border-b border-white-light px-5 py-4 dark:border-[#191e3a]">
        <h2 id="email-preview-title" class="text-base font-semibold text-black dark:text-white">
          Email preview
        </h2>
        <button
          type="button"
          class="btn btn-sm rounded-full px-3"
          (click)="closePreview()"
        >
          Close
        </button>
      </div>
      <div class="max-h-[calc(90vh-4rem)] overflow-y-auto p-5">
        <div class="mb-4 rounded-xl border border-white-light bg-[#f8fafc] px-4 py-3 dark:border-[#191e3a] dark:bg-[#0b1220]">
          <p class="mb-1 text-[11px] font-semibold uppercase tracking-wide text-gray-500 dark:text-white-dark">Subject</p>
          <p class="text-sm font-semibold text-black dark:text-white">{{ previewSubject || '(No subject)' }}</p>
        </div>
        <iframe
          #listPreviewFrame
          class="block w-full min-h-[480px] border-0 bg-[#eef2f7]"
          title="Email template preview"
          sandbox="allow-same-origin"
        ></iframe>
      </div>
    </div>
  </dialog>
}
